export const certificates = [
  {
    id: 'bsc',
    title: 'Bachelor of Science, Agriculture',
    issuer: 'University of Reading',
    date: '6 July 1974',
    citation: 'Admitted to the Degree of Bachelor of Science, having satisfied the Examiners in Agriculture and subjects allied thereto.',
    url: 'https://cdn.magicpatterns.com/uploads/uyCyjc27vAHYqU4uj9msRQ/James_Godfrey_University_of_Reading_BSc_1974.pdf',
  },
  {
    id: 'frags',
    title: 'Certificate of Fellowship (FRAgS)',
    issuer: 'Council for Awards of Royal Agricultural Societies',
    date: '26 April 2000',
    citation: 'Elected a Fellow of Royal Agricultural Societies in recognition of outstanding service to and achievement within the agricultural industry.',
    url: 'https://cdn.magicpatterns.com/uploads/xwJmKHmmWno7xDCvLamBB4/Jaames_Godfery_CARAS_Fellow_2000.pdf',
  },
  {
    id: 'obe',
    title: 'Officer of the Order of the British Empire',
    issuer: 'HM Queen Elizabeth II',
    date: '31 December 2002',
    citation: 'Appointed an Ordinary Officer of the Civil Division of the Most Excellent Order of the British Empire, given at the Court at Saint James’s.',
    url: 'https://cdn.magicpatterns.com/uploads/wFJgyXgC8srYcxYTq42xRK/James_Godfrey_OBE_award_2002.pdf',
  },
  {
    id: 'fiod',
    title: 'Fellow of the Institute of Directors',
    issuer: 'Institute of Directors',
    date: '2 November 2004',
    citation: 'Elected a Fellow of the Institute of Directors.',
    url: 'https://cdn.magicpatterns.com/uploads/8TeQFY8SuKEk56aDp4ay4a/James_Godfrey_Fellow_Institute_of_Directors_2004.pdf',
  },
  {
    id: 'wpc',
    title: 'World Potato Congress Industry Award',
    issuer: 'World Potato Congress, Boise, Idaho, USA',
    date: '23 August 2006',
    citation: 'In recognition of significant contribution and dedication to the growth and development of the global potato industry.',
    url: 'https://cdn.magicpatterns.com/uploads/oMG3DXmu9iB9En7qGzddcV/James_Godfrey_World_Potato_Congress_award_2006.pdf',
  },
  {
    id: 'dsc',
    title: 'Honorary Doctor of Science',
    issuer: 'University of Reading',
    date: '15 December 2007',
    citation: 'Conferred by the authority of the Council and the Senate of the University at the December Congregation.',
    url: 'https://cdn.magicpatterns.com/uploads/6HSEBNv6oPwo4qF1uX1ACy/James_Godfrey_University_of_Reading_Hon_DSc_2007.pdf',
  },
  {
    id: 'rase-award',
    title: 'National Agricultural Award 2015',
    issuer: 'Royal Agricultural Society of England',
    date: '2 September 2015',
    citation: 'Presented by the Royal Agricultural Society of England.',
    url: 'https://cdn.magicpatterns.com/uploads/bvbHhbrPAUAfJ3MXs5CYYm/James_Godfrey_RASE_Agriculture_Award_2015.pdf',
  },
  {
    id: 'frase',
    title: 'Honorary Fellow (FRASE)',
    issuer: 'Royal Agricultural Society of England',
    date: '3 June 2024',
    citation: 'Granted Honorary Fellowship of the Royal Agricultural Society of England.',
    url: 'https://cdn.magicpatterns.com/uploads/9Z2Ap1w3tAhV1E4kq4Ywe7/James_Godfrey_RASE_Honorary_Fellow_2024.pdf',
  },
];

type Award = {
  title: string;
  short: string;
  year: string;
  featured?: boolean;
  certificateId?: string;
};

export const awards: Award[] = [
  { title: 'Fellow of the Royal Agricultural Societies', short: 'FRAgS', year: '2000', certificateId: 'frags' },
  { title: 'OBE for services to agricultural research', short: 'OBE', year: '2002', featured: true, certificateId: 'obe' },
  { title: 'Fellow of the Institute of Directors', short: 'FIoD', year: '2004', certificateId: 'fiod' },
  { title: 'World Potato Congress Industry Award', short: 'WPC', year: '2006', certificateId: 'wpc' },
  { title: 'Honorary DSc, University of Reading', short: 'DSc', year: '2007', certificateId: 'dsc' },
  { title: 'Potato Council Award', short: 'PC', year: '2008' },
  { title: 'RASE National Agricultural Award', short: 'RASE', year: '2015', certificateId: 'rase-award' },
  { title: 'Fellow of NIAB', short: 'NIAB', year: '2022' },
  { title: 'Honorary Fellow, RASE', short: 'FRASE', year: '2024', certificateId: 'frase' },
  { title: "Lincolnshire Agricultural Society President's Award", short: 'LAS', year: '2026' },
];

export const qualifications = [
  { title: 'BSc Agriculture', issuer: 'University of Reading', year: '1974' },
  { title: 'Fellow (FRAgS)', issuer: 'Council for Awards of Royal Agricultural Societies', year: '2000' },
  { title: 'Fellow (FIoD)', issuer: 'Institute of Directors', year: '2004' },
  { title: 'Honorary Doctor of Science (DSc)', issuer: 'University of Reading', year: '2007' },
  { title: 'Honorary Fellow (FRASE)', issuer: 'Royal Agricultural Society of England', year: '2024' },
];

export const references = [
  { source: 'NIAB', title: 'Jim Godfrey, Chairman profile', url: 'https://www.niab.com/about/people/jim-godfrey', display: 'niab.com/about/people/jim-godfrey' },
  { source: 'IRRI', title: 'Board of Trustees profile', url: 'https://www.irri.org/about-us/our-people/jim-godfrey', display: 'irri.org/about-us/our-people/jim-godfrey' },
  { source: 'Ceres Agri-Tech', title: 'Investment Committee profile', url: 'https://www.ceresagritech.org/about/team/jim-godfrey', display: 'ceresagritech.org/about/team/jim-godfrey' },
  { source: 'LinkedIn', title: 'Professional profile', url: 'https://www.linkedin.com/in/james-jim-godfrey-733565b', display: 'linkedin.com/in/james-jim-godfrey-733565b' },
];
